/* globals Store */
import ObjDataSet from "@/vue-dlb/models/objdataset";
import appUtil from '@/vue-dlb/utils/app-util'
import vueCookies from 'vue-cookies';
import config from '@/vue-caas/config/config.js';

const isDlbMybatis = config.isDlbMybatis;

function setUserDataSet(trset) {
  console.log('------ SET USER DATA SET -------');
  let user_id = vueCookies.get('user-id');
  let user_timezone = vueCookies.get('gmt-timezone');
  let userData = {
    header: ['USER_IDNO','USER_TIMEZONE'],
    data: [{
      USER_IDNO: `${user_id}`,
      USER_TIMEZONE: `${user_timezone}`
    }]
  };

  let userSet = new ObjDataSet("userSet");
  userSet = appUtil.addDataHeader(userData, userSet);
  trset.AddDataSet("S", "DS99", userSet);
  return trset;
}

export function selectUserDataSet (trset) {
  trset = setUserDataSet(trset);    // user 정보를 DataSet에 담아보낸다.
  return trset;
}

export function selectDataSetByDataSet (trset) {
  trset = setUserDataSet(trset);    // user 정보를 DataSet에 담아보낸다.
  trset.Action = "/UserDispatcherServlet";
  //trset.Parameters = "ejbName=PROCEDUREEJB,methodName=selectDataSetByDataSet,spName=";
  //trset.Parameters += trset.CallMethod;
  if (isDlbMybatis) trset.moduleName = "MYBATIS";
  else trset.moduleName = "PROCEDURE";
  trset.methodName = "selectDataSetByDataSet";
  return {trSet: JSON.stringify(trset)};
}

export function selectDataSetByDataSetForComm (trset) {
  trset = setUserDataSet(trset);    // user 정보를 DataSet에 담아보낸다.
  trset.Action = "/UserDispatcherServlet";
  //trset.Parameters = "ejbName=PROCEDUREEJB,methodName=selectDataSetByDataSet,spName=";
  //trset.Parameters += trset.CallMethod;
  trset.moduleName = "PROCEDURE";
  trset.methodName = "selectDataSetByDataSet";
  return {trSet: JSON.stringify(trset)};
}

export function execSPByDataSet (trset) {
  trset = setUserDataSet(trset);    // user 정보를 DataSet에 담아보낸다.
  trset.Action = "/UserDispatcherServlet";
  //trset.Parameters = "ejbName=PROCEDUREEJB,methodName=execSPByDataSet,spName=";
  if (isDlbMybatis) trset.moduleName = "MYBATIS";
  else trset.moduleName = "PROCEDURE";
  trset.methodName = "execSPByDataSet";
  return {trSet: JSON.stringify(trset)};
}

export function callByDataSet (trset) {
  trset = setUserDataSet(trset);    // user 정보를 DataSet에 담아보낸다.
  trset.Action = "/UserDispatcherServlet";
  //trset.Parameters = "ejbName=COMMONEJB,methodName=callByDataSet,tranID=";
  trset.moduleName = "COMMON";
  trset.methodName = "callByDataSet";
  return  {trSet: JSON.stringify(trset)};
}

